import React from 'react'

const FailedEvina = () => {
  return (
     <div>
      <div id="notfound">
                <div className="notfound">
                    <div className="notfound-404">
                        <h1>Authentic</h1>
                        <h2>Failed</h2>
                    </div>
                </div>
            </div>
    </div>
  )
}

export default FailedEvina
